import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AppConfig } from "../Utilities/app-config.service";
import { HelperService } from "./helper.service";
import { ResultStatus } from '../models/result-status';

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(
    private apiService: ApiService,
    private appConfig: AppConfig
  ) {}

  getNotifications() {
    return this.apiService.get(this.appConfig.GetUrl("getNotifications"));
  }

  readNotification(id, isRead) {
    return this.apiService.put(
      this.appConfig
        .GetUrl("readNotification")
        .replace("[NOTIFICATIONID]", id)
        .replace("[ISREAD]", isRead)
    );
  }

  getNotificationsCount() {
    return this.apiService.get(this.appConfig.GetUrl("getNotificationsCount"));
  }

  updateNotificationCount() {
    this.getNotificationsCount().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.appConfig.SharedComponent.notificationCount = result.Data;
      } else {
        this.appConfig.SharedComponent.notificationCount = 0;
      }
    });
  }
}
